import {Interaction} from "ol/interaction";
import {singleClick} from "ol/events/condition";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {WMTS} from "ol/source";
import WMTSTileGrid from "ol/tilegrid/WMTS";

export interface WmtsGetfeatureinfoInteractionOptions {
    wmtsCapabilities: any;
    source: WMTS;
}

export function supportsGetFeatureInfo(capabilities: any): boolean {
    if (!capabilities) return false;

    const ops = capabilities.OperationsMetadata || {};
    const getFeatureInfo = ops.GetFeatureInfo;

    return !!(getFeatureInfo
        && getFeatureInfo.DCP
        && getFeatureInfo.DCP.HTTP
        && getFeatureInfo.DCP.HTTP.Get);
}

export class WmtsGetFeatureInfoInteraction extends Interaction {
    constructor(options: WmtsGetfeatureinfoInteractionOptions) {
        super({
            handleEvent(event) {
                if (!singleClick(event)) {
                    return false;
                }

                const caps = options.wmtsCapabilities;
                const ops = caps.OperationsMetadata || {};
                const getFeatureInfo = ops.GetFeatureInfo;
                const get = getFeatureInfo.DCP.HTTP.Get[0];
                const url = get.href;

                const source = options.source;

                const coordinate = event.map.getCoordinateFromPixel(event.pixel)
                const grid = source.getTileGrid() as WMTSTileGrid;
                const resolution = event.frameState.viewState.resolution;

                const [z, x, y] = grid.getTileCoordForCoordAndResolution(coordinate, resolution);
                const matrixId = grid.getMatrixId(z);

                const [txmin, tymin, txmax, tymax] = grid.getTileCoordExtent([z, x, y]);
                const tileSize = grid.getTileSize(z);
                const [tw, th] = Array.isArray(tileSize) ? tileSize : [tileSize, tileSize];

                // linearly interpolate the click coordinate along the tile extent
                const tileWidthMap = txmax - txmin;
                const tileHeightMin = tymax - tymin;
                const i = (((coordinate[0] - txmin) / tileWidthMap) * tw).toFixed(0);
                const j = (((coordinate[1] - tymin) / tileHeightMin) * th).toFixed(0);

                const params = new URLSearchParams({
                    Service: "WMTS",
                    Version: source.getVersion(),
                    Request: "GetFeatureInfo",
                    layer: source.getLayer(),
                    style: source.getStyle(),
                    // FORMAT: source.getFormat(),
                    TileMatrixSet: source.getMatrixSet(),
                    TileMatrix: matrixId,
                    TileRow: `${y}`,
                    TileCol: `${x}`,
                    infoformat: 'application/vnd.ogc.gml',
                    i,
                    j
                });

                fetch(`${url}${url[url.length - 1] === '?' ? '' : '?'}${params}`).then(r => {
                    console.log(r);
                })

                return true;
            }
        });

        this.on('change:active', () => {
            const isActive = this.getActive();

            if (isActive) {
                this.getMap().addLayer(this.layer);
            } else {
                this.getMap().removeLayer(this.layer);
            }
        })
    }

    layer: VectorLayer = new VectorLayer({
        source: new VectorSource({
            features: []
        })
    });
}